export { default } from "./ProfilePage"


// WEBPACK FOOTER //
// ./src/screens/Profile/index.ts